<template>
  <b-modal id="customer-show-quotation" class="customer-show-quotation" ref="modal" :title="dialog_title" hide-footer>
    <customer-choose-pack @add="doAddPack" ref="choosepack"></customer-choose-pack>

    <div class="row form-group">
      <div class="col-md-2 customer-show-quotation__left">
        <div class="customer-info customer-show-quotation__left-section">
          <div class="customer-photo" :style="{ 'background-image': 'url(' + customer.photo + ')' }"></div>
          <div class="customer-data">
            <div class="customer-data__name">
              {{ customer_name }}
            </div>
            {{ customer.phone || customer.phone_alt }}
            <br />
            {{ customer_nif }}
          </div>
        </div>

        <div v-if="user_id" class="customer-show-quotation__left-section">
          <strong>Creado por:</strong> {{ quotation_user_name }}
        </div>

        <div class="customer-show-quotation__left-section">
          <input id="quotation_core_date" type="date" class="form-control wabident-small" v-model="quotation_date" />
          <label class="wabident-info" for="quotation_core_date">Fecha plan</label>
        </div>

        <div class="customer-show-quotation__left-section">
          <input id="quotation_expiry_date" type="date" class="form-control wabident-small" v-model="expiry_date" />
          <label class="wabident-info" for="quotation_expiry_date">Fecha caducidad</label>
        </div>

        <div class="customer-show-quotation__left-section">
          <input id="quotation_code" type="text" class="form-control wabident-small" readonly
            :value="pretty_quotation_code" />
          <label class="wabident-info" for="quotation_code">Cod plan</label>
        </div>

        <div class="customer-show-quotation__left-section" v-if="approved_at">
          <input id="approved_at" type="date" class="form-control wabident-small" readonly
            :value="pretty_approved_at" />
          <label class="wabident-info" for="approved_at">Fecha Aprobado</label>
        </div>
      </div>

      <div class="col-md-10 customer-show-quotation__right">
        <div class="row form-group">
          <div class="col">
            <input type="text" class="form-control wabident-small" v-model="notes" id="quotation_notes"
              placeholder="Nombre del plan de Tratamiento" />
            <label for="quotation_notes" class="wabident-info">Nombre del Plan: <strong>(Obligatorio)</strong></label>
          </div>

          <div class="col">
            <select id="quot_assigned_doctor" v-model="assigned_doctor_id" class="custom-select">
              <option :value="null">Selecciona Doctor(a)</option>
              <option v-for="(doctor, i) in doctors" :key="i" :value="doctor.doctor.id"
                :disabled="doctor.is_active == 0">
                {{ doctor.name }}
              </option>
            </select>
            <label for="quot_assigned_doctor" class="wabident-info">Doctor(a) asignado o responsable</label>
          </div>

          <div class="col" v-if="products_price_per_tariff">
            <select if="tariff_id" v-model="tariff_id" id="tariff_id" class="custom-select">
              <option :value="null">Por Defecto</option>
              <option v-for="(tariff, id) in tariffs" :value="id" :key="id">
                {{ tariff.name }}
              </option>
            </select>
            <label for="tariff_id" class="wabident-info">Tarifa</label>
          </div>

          <div class="col" v-if="is_editing">
            <input type="text" class="form-control wabident-small" v-model="reject_reason" id="reject_reason"
              placeholder="¿Rechazado? Indica aquí las razones y se marcará como rechazado atomáticamente" />
            <label for="reject_reason" class="wabident-info">Razón del rechazo</label>
          </div>
        </div>

        <div class="row form-group">
          <div class="col">
            <table class="table treatments-table">
              <thead>
                <tr>
                  <th colspan="1">ORDEN</th>
                  <th colspan="8">
                    TRATAMIENTO <span v-if="is_dental"> / PIEZA</span>
                  </th>
                  <th colspan="1">P.UNIT</th>
                  <th colspan="1">CANT.</th>
                  <th colspan="1">BASE</th>
                  <th colspan="1">
                    <div class="global-discount mb-2" v-if="quotation_lines.length > 1">
                      <input type="number" v-model="global_discount" min="0" max="100"
                        class="form-control wabident-xsmall" />
                    </div>
                    DESC. (%)
                  </th>
                  <th colspan="1">DESC. (€)</th>
                  <th colspan="1">TOTAL</th>
                  <th colspan="1">APROB.</th>
                  <th colspan="1"></th>
                </tr>
              </thead>

              <draggable v-model="quotation_lines" handle=".handle" tag="tbody" @update="onLinesDragged">
                <tr class="quotation-line" v-for="(line, index) in quotation_lines" :key="getLineKey(line, index)">
                  <td class="quotation-line-order handle" colspan="1"
                    style="vertical-align: middle; text-align: center">
                    <div class="d-flex align-items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M8.20023 3.30013C8.20023 4.29431 7.39428 5.10025 6.4001 5.10025C5.40592 5.10025 4.59998 4.29431 4.59998 3.30013C4.59998 2.30594 5.40592 1.5 6.4001 1.5C7.39428 1.5 8.20023 2.30594 8.20023 3.30013ZM8.20023 10.4998C8.20023 11.494 7.39428 12.2999 6.4001 12.2999C5.40592 12.2999 4.59998 11.494 4.59998 10.4998C4.59998 9.50561 5.40592 8.69966 6.4001 8.69966C7.39428 8.69966 8.20023 9.50561 8.20023 10.4998ZM6.4001 19.5C7.39428 19.5 8.20023 18.6941 8.20023 17.6999C8.20023 16.7057 7.39428 15.8997 6.4001 15.8997C5.40592 15.8997 4.59998 16.7057 4.59998 17.6999C4.59998 18.6941 5.40592 19.5 6.4001 19.5ZM15.3999 3.30013C15.3999 4.29431 14.5939 5.10025 13.5998 5.10025C12.6056 5.10025 11.7996 4.29431 11.7996 3.30013C11.7996 2.30594 12.6056 1.5 13.5998 1.5C14.5939 1.5 15.3999 2.30594 15.3999 3.30013ZM13.5998 12.2999C14.5939 12.2999 15.3999 11.494 15.3999 10.4998C15.3999 9.50561 14.5939 8.69966 13.5998 8.69966C12.6056 8.69966 11.7996 9.50561 11.7996 10.4998C11.7996 11.494 12.6056 12.2999 13.5998 12.2999ZM15.3999 17.6999C15.3999 18.6941 14.5939 19.5 13.5998 19.5C12.6056 19.5 11.7996 18.6941 11.7996 17.6999C11.7996 16.7057 12.6056 15.8997 13.5998 15.8997C14.5939 15.8997 15.3999 16.7057 15.3999 17.6999Z"
                          fill="#A6AAB4"></path>
                      </svg>
                      <span class="quotation-line-order__num d-flex align-items-center">
                        {{ index + 1 }}
                      </span>
                    </div>
                  </td>

                  <td colspan="8">
                    <strong>{{ prettyLineName(line) }}</strong>
                    <div v-if="is_dental && !line.lock_teeth" class="mt-1 d-flex" style="gap:10px">
                      <span>
                        Piezas:&nbsp;<teeth-selector :lock="line.lock_teeth" v-model="line.teeth"></teeth-selector>
                      </span>
                      <span>
                        Caras:&nbsp;<face-selector :lock="line.lock_teeth" v-model="line.faces">
                        </face-selector>
                      </span>
                      <div class="form-check form-check-inline">
                        <input v-model="line.per_tooth" class="form-check-input" type="checkbox"
                          :id="index + '_line_tooth'" value="true" />
                        <label class="form-check-label" :for="index + '_line_tooth'">Por pieza</label>
                      </div>

                    </div>
                    <div v-else-if="is_dental">
                      <i class="fas fa-lock" v-b-popover.hover.top="'Edita directamente el tratamiento si quieres cambiar las piezas y las caras.'
                        " title="LINEA BLOQUEADA"></i>
                      <strong><small>{{ prettyTeeth(line) }}</small></strong>
                    </div>
                  </td>

                  <td colspan="1">
                    <input type="number" v-model.number="line.price" class="form-control wabident-xsmall" />
                  </td>
                  <td colspan="1">
                    <input type="number" :value="getLineQuantity(line)" @input="setLineQuantity(line, $event)" min="1"
                      class="form-control wabident-xsmall" :readonly="is_editing || line.per_tooth" />
                  </td>
                  <td colspan="1">{{ prettyPrice(line) }}</td>
                  <td colspan="1">
                    <input type="number" v-model.number="line.discount" min="0" max="100"
                      class="form-control wabident-xsmall" />
                  </td>
                  <td colspan="1">
                    <input type="number" v-model.number="line.abs_discount" min="0"
                      class="form-control wabident-xsmall" />
                  </td>
                  <td colspan="1">{{ prettyNetPrice(line) }}</td>
                  <td colspan="1" align="center" valign="center" class="text-center">
                    <div class="form-check form-check-mark form-check-inline">
                      <input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="line.is_approved"
                        class="form-check-input" :id="'is_approved_' + index" />
                      <label class="form-check-label" :for="'is_approved_' + index"></label>
                    </div>
                  </td>
                  <td colspan="1" @click="removeQuotationLine(index)" class="trash-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <path fill-rule="evenodd" d="M2 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1z"
                        clip-rule="evenodd" />
                      <path fill-rule="evenodd"
                        d="M10 3a1 1 0 0 0-1 1v1h6V4a1 1 0 0 0-1-1h-4zm7 2V4a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v1H5a1 1 0 0 0-1 1v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6a1 1 0 0 0-1-1h-2zM6 7v13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7H6z"
                        clip-rule="evenodd" />
                      <path fill-rule="evenodd"
                        d="M10 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1zM14 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1z"
                        clip-rule="evenodd" />
                    </svg>
                  </td>
                </tr>
              </draggable>

              <tr style="border-top: 1px var(--theme-grey) solid">
                <td style="padding: 5px 0" :colspan="is_core ? 16 : 15">
                  <div class="customer-show-quotation__product-selector d-flex">
                    <!-- Product Selector -->
                    <div style="flex-grow: 1">
                      <v-select ref="psearch" class="wabident-selector" id="product_selector" @search="searchProducts"
                        :filterable="false" :options="products" placeholder="Busca el tratamiento/producto aquí ..."
                        v-model="selected_product"></v-select>
                      <label for="product_selector" class="wabident-info">Añadir producto nuevo</label>
                    </div>

                    <!-- Cat Selector -->
                    <div>
                      <select v-model="product_category_id" id="product_category_id" class="custom-select">
                        <option :value="null">Todas</option>
                        <option v-for="(category, id) in categories" :key="id" :value="category.id">
                          {{ category.name }}
                        </option>
                      </select>
                      <label for="product_category_id" class="wabident-info">Filtrar por unidad</label>
                    </div>

                    <!-- Add Product -->
                    <button style="height: 50.5px" class="btn btn-wabident-round" :disabled="!selected_product"
                      @click="addProductToQuotation">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <g clip-path="url(#clip0_207_1621)">
                          <path
                            d="M10.4508 5.05076L6.94923 5.05076L6.94923 1.54919C6.94923 1.29745 6.84922 1.05601 6.67121 0.877996C6.49319 0.699983 6.25176 0.599976 6.00001 0.599976C5.74826 0.599976 5.50682 0.699983 5.32881 0.877996C5.15079 1.05601 5.05079 1.29745 5.05079 1.54919L5.05079 5.05076L1.54922 5.05076C1.29748 5.05076 1.05604 5.15076 0.878025 5.32878C0.700012 5.50679 0.600006 5.74823 0.600006 5.99998C0.600006 6.25172 0.700012 6.49316 0.878025 6.67117C1.05604 6.84919 1.29748 6.94919 1.54922 6.94919L5.05079 6.94919L5.05079 10.4508C5.05079 10.7025 5.15079 10.9439 5.32881 11.122C5.50682 11.3 5.74826 11.4 6.00001 11.4C6.25175 11.4 6.49319 11.3 6.6712 11.122C6.84922 10.9439 6.94922 10.7025 6.94922 10.4508L6.94922 6.94919L10.4508 6.94919C10.7025 6.94919 10.944 6.84919 11.122 6.67117C11.3 6.49316 11.4 6.25172 11.4 5.99998C11.4 5.74823 11.3 5.50679 11.122 5.32878C10.944 5.15076 10.7025 5.05076 10.4508 5.05076Z"
                            fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_207_1621">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Añadir producto
                    </button>

                    <!-- Add Pack -->
                    <button style="height: 50.5px" class="btn btn-wabident-round" @click="addPack">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <g clip-path="url(#clip0_207_1621)">
                          <path
                            d="M10.4508 5.05076L6.94923 5.05076L6.94923 1.54919C6.94923 1.29745 6.84922 1.05601 6.67121 0.877996C6.49319 0.699983 6.25176 0.599976 6.00001 0.599976C5.74826 0.599976 5.50682 0.699983 5.32881 0.877996C5.15079 1.05601 5.05079 1.29745 5.05079 1.54919L5.05079 5.05076L1.54922 5.05076C1.29748 5.05076 1.05604 5.15076 0.878025 5.32878C0.700012 5.50679 0.600006 5.74823 0.600006 5.99998C0.600006 6.25172 0.700012 6.49316 0.878025 6.67117C1.05604 6.84919 1.29748 6.94919 1.54922 6.94919L5.05079 6.94919L5.05079 10.4508C5.05079 10.7025 5.15079 10.9439 5.32881 11.122C5.50682 11.3 5.74826 11.4 6.00001 11.4C6.25175 11.4 6.49319 11.3 6.6712 11.122C6.84922 10.9439 6.94922 10.7025 6.94922 10.4508L6.94922 6.94919L10.4508 6.94919C10.7025 6.94919 10.944 6.84919 11.122 6.67117C11.3 6.49316 11.4 6.25172 11.4 5.99998C11.4 5.74823 11.3 5.50679 11.122 5.32878C10.944 5.15076 10.7025 5.05076 10.4508 5.05076Z"
                            fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_207_1621">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Añadir pack
                    </button>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="13">
                  <div v-if="addable_treatments.length">
                    <select v-model="selected_add_teeth" @change="addTreatment" class="custom-select form-control">
                      <option value>
                        Añadir un tratamiento sin planificar
                      </option>
                      <option v-for="t in addable_treatments" :key="t.id" :value="t">
                        {{ t.full_name }}
                      </option>
                    </select>
                  </div>
                </td>
                <td v-show="!hide_total" colspan="2">
                  <strong class="total">BASE</strong><br />
                  {{ pretty_total }}
                </td>
                <td v-show="!hide_total" colspan="2">
                  <strong class="total">TOTAL</strong><br />
                  {{ pretty_net_total }}
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="row form-group mb-0">
          <div class="col buttons-column align-items-center">
            <button @click="submitQuotation()" :disabled="!can_save" type="button"
              class="btn btn-primary btn-wabident-round float-left">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path
                  d="M10.4987 3.29875L8.70122 1.50128C8.50832 1.30838 8.2467 1.20001 7.97391 1.20001L2.22852 1.20001C1.66045 1.20001 1.19995 1.66051 1.19995 2.22858L1.19995 9.77144C1.19995 10.3395 1.66045 10.8 2.22852 10.8L9.77138 10.8C10.3395 10.8 10.8 10.3395 10.8 9.77144L10.8 4.02606C10.8 3.75326 10.6916 3.49164 10.4987 3.29875ZM5.99995 9.42858C5.24254 9.42858 4.62852 8.81457 4.62852 8.05716C4.62852 7.29974 5.24254 6.68573 5.99995 6.68573C6.75737 6.68573 7.37138 7.29974 7.37138 8.05716C7.37138 8.81457 6.75737 9.42858 5.99995 9.42858ZM8.0571 2.90316L8.0571 5.05716C8.0571 5.19916 7.94196 5.3143 7.79995 5.3143L2.82852 5.3143C2.68652 5.3143 2.57138 5.19916 2.57138 5.05716L2.57138 2.82858C2.57138 2.68658 2.68652 2.57144 2.82852 2.57144L7.72538 2.57144C7.79359 2.57144 7.85899 2.59853 7.9072 2.64676L7.98177 2.72133C8.00566 2.74521 8.0246 2.77355 8.03752 2.80475C8.05045 2.83595 8.0571 2.86939 8.0571 2.90316Z"
                  fill="white" />
              </svg>
              Guardar plan
            </button>
            <button @click="submitApproval()" v-if="!is_editing" :disabled="!can_save" type="button"
              class="btn btn-primary btn-wabident-round float-left">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <g clip-path="url(#clip0_203_2452)">
                  <path
                    d="M4.73565 10.0246C4.63218 10.1279 4.49194 10.1859 4.34574 10.1859C4.19953 10.1859 4.0593 10.1279 3.95582 10.0246L0.842471 6.91045C0.765633 6.83368 0.704678 6.74251 0.663091 6.64217C0.621503 6.54182 0.600097 6.43427 0.600097 6.32565C0.600097 6.21702 0.621503 6.10947 0.663091 6.00912C0.704678 5.90878 0.765633 5.81762 0.842471 5.74084L1.23225 5.35235C1.30903 5.27551 1.4002 5.21456 1.50054 5.17297C1.60088 5.13138 1.70844 5.10998 1.81706 5.10998C1.92568 5.10998 2.03324 5.13138 2.13358 5.17297C2.23393 5.21456 2.32509 5.27551 2.40187 5.35235L4.34561 7.2948L9.59824 2.04242C9.67502 1.96559 9.76618 1.90463 9.86653 1.86304C9.96687 1.82146 10.0744 1.80005 10.183 1.80005C10.2917 1.80005 10.3992 1.82146 10.4996 1.86304C10.5999 1.90463 10.6911 1.96559 10.7679 2.04242L11.1576 2.43221C11.2345 2.50898 11.2954 2.60015 11.337 2.70049C11.3786 2.80084 11.4 2.90839 11.4 3.01701C11.4 3.12563 11.3786 3.23319 11.337 3.33353C11.2954 3.43388 11.2345 3.52504 11.1576 3.60182L4.73565 10.0246Z"
                    fill="white" />
                </g>
                <defs>
                  <clipPath id="clip0_203_2452">
                    <rect width="12" height="12" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              Aprobar plan
            </button>

            <div class="d-flex justify-content-end align-items-center">
              <button :disabled="is_loading" @click="onDelete" v-show="is_editing" class="btn btn-wabident-delete"
                style="
                  flex: 0 0 40px;
                  width: 40px;
                  height: 40px;
                  border-radius: 20px;
                "></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    customer: { required: true },
    clinic: { default: null },
  },
  data() {
    return {
      global_discount: 0,
      quotation_id: 0,
      quotation_code: "",
      notes: "",
      expiry_date: new Date().toISODate(),
      quotation_date: new Date().toISODate(),
      approved_at: null,
      user_id: null,
      is_editing: false,
      is_loading: false,
      quotation_lines: [],
      selected_treatments: [],
      available_treatments: [],
      selected_add_teeth: "",
      reject_reason: "",
      hide_total: false,
      assigned_doctor_id: null,
      recommends_doctor_id: null,
      selected_product: null,
      product_category_id: null,
      searched_products: [],
      products: [],
      hierarchy: [],
      tariff_id: null,
    };
  },
  computed: {
    is_dental() {
      return this.clinic && this.clinic.type == "dental";
    },
    can_save() {
      return (
        !this.is_loading &&
        this.quotation_lines.length > 0 &&
        this.quotation_date !== null &&
        (this.is_editing || this.expiry_date !== null) &&
        this.notes !== null &&
        this.notes !== ""
      );
    },
    enable_product_selection() {
      return !this.available_treatments || !this.available_treatments.length;
    },
    quotation_disable_grouping() {
      return true;
    },
    doctors() {
      if (!this.clinic) return [];
      return this.clinic.doctors.filter((x) => {
        return x.is_active != 0;
      });
    },
    quotation_user_name() {
      if (!this.clinic || !this.user_id) return "";

      for (let i = 0; i < this.clinic.users.length; i++) {
        let user = this.clinic.users[i];
        if (user.id == this.user_id) {
          return user.name;
        }
      }

      return "";
    },
    clinic_type() {
      if (!this.clinic) return null;
      return this.clinic.type;
    },
    is_minor() {
      if (this.customer.is_incapacitated) return true;
      let birthday = moment(this.customer.birth_date);
      let date = moment(this.quotation_date);
      let years = date.diff(birthday, "years");
      return years < 18;
    },
    customer_name() {
      return this.is_minor
        ? "Rep: " + this.customer.adult_name
        : this.customer.full_name;
    },
    customer_nif() {
      return this.is_minor ? this.customer.adult_nif : this.customer.nif;
    },
    addable_treatments() {
      return this.available_treatments.filter((x) => {
        return (
          this.selected_treatments.filter((y) => {
            return x.id == y.id;
          }).length <= 0
        );
      });
    },
    total() {
      return this.quotation_lines.reduce((cur, val) => {
        const quantity = this.getLineQuantity(val);
        return cur + Number(val.price) * Number(quantity);
      }, 0);
    },
    net_total() {
      return this.quotation_lines.reduce((cur, val) => {
        const quantity = this.getLineQuantity(val);
        return (
          cur +
          Number(val.price) *
          Number(quantity) *
          (1 - Number(val.discount) / 100) -
          val.abs_discount
        );
      }, 0);
    },
    pretty_quotation_date() {
      return this.quotation_date;
    },
    pretty_quotation_code() {
      if (this.is_core) {
        return `Plan #${this.quotation_code}`;
      } else {
        return `Presupuesto #${this.quotation_code}`;
      }
    },
    pretty_approved_at() {
      if (!this.approved_at) return "";
      return this.approved_at.toISODate();
    },
    pretty_net_total() {
      return WabiDent.fmtMoney(this.net_total);
    },
    pretty_total() {
      return WabiDent.fmtMoney(this.total);
    },
    dialog_title() {
      if (this.is_core) {
        return this.is_editing ? "Modificar Plan" : "Crear Plan";
      } else {
        return this.is_editing ? "Modificar Presupuesto" : "Crear Presupuesto";
      }
    },
    categories() {
      let ret = [];
      this.hierarchy.forEach((cat) => {
        this.addCategory(cat, ret, 0);
      });
      return ret;
    },
    products_price_per_tariff() {
      if (!this.clinic) {
        return false;
      }

      return this.clinic.config.products_price_per_tariff;
    },
    tariffs() {
      if (!this.clinic) {
        return {};
      }
      return this.clinic.tariffs;
    },
    ...mapGetters(["msgwindow", "errorwindow", "is_core"]),
  },
  watch: {
    tariff_id() {
      this.quotation_lines.forEach((line) => {
        line.price = this.getProductPrice(line.product);
      });
      this.$forceUpdate();
    },
    global_discount(val) {
      this.quotation_lines.forEach((line) => {
        line.discount = val;
      });
      this.$forceUpdate();
    },
  },
  methods: {
    getLineQuantity(line) {
      if (line.per_tooth) {
        return line.teeth.length || 1;
      }
      return line.quantity;
    },
    setLineQuantity(line, event) {
      if (line.per_tooth) {
        line.quantity = line.teeth.length || 1;
      }
      console.log(event);
      line.quantity = event.target.value;
    },
    onLinesDragged() {
      this.$forceUpdate();
    },
    getLineKey(line, index) {
      if (!line.id) {
        line.id = crypto.randomUUID();
      }

      return line.id;
    },
    prettyLineName(line) {
      return line.product.name;
    },
    prettyTeeth(l) {
      if (!l) {
        return "";
      }

      const teeth = l.teeth ? l.teeth : [];
      const faces = l.faces ? l.faces : [];
      const ret = teeth.concat(faces);

      if (!ret.length) {
        return "";
      }

      return "(" + ret.join(",") + ")";
    },
    prettyUnitPrice(line) {
      return WabiDent.fmtMoney(line.price);
    },
    prettyPrice(line) {
      const quantity = this.getLineQuantity(line);
      return WabiDent.fmtMoney(line.price * quantity);
    },
    prettyNetPrice(line) {
      const quantity = this.getLineQuantity(line);
      let price =
        Number(line.price) *
        Number(quantity) *
        (1 - Number(line.discount) / 100);

      price -= Number(line.abs_discount);
      return WabiDent.fmtMoney(price);
    },
    getProductPrice(product) {
      let product_price = product.price;
      if (this.products_price_per_tariff && this.tariff_id) {
        const ppt = product.prices.by_tariff;
        if (ppt) {
          product_price = ppt[this.tariff_id] ? ppt[this.tariff_id] : product_price;
        }
      }
      return product_price;
    },
    updateQuotationLines() {
      let lines = {};
      this.selected_treatments.forEach((treatment, index) => {
        let id = treatment.product.id;
        if (this.quotation_disable_grouping) {
          id = index;
        }

        lines[id] = lines[id] || {
          product: treatment.product,
          quantity: 0,
          treatments: [],
          teeth: [],
          faces: [],
          discount: 0,
          abs_discount: 0,
          price: this.getProductPrice(treatment.product),
          is_approved: false,
          treatment_pack_id: null,
        };

        lines[id].teeth = lines[id].teeth.concat(treatment.teeth);
        lines[id].quantity += 1;
        lines[id].treatments.push(treatment);
      });

      this.$set(this, "quotation_lines", Object.values(lines));
    },

    updateQuotationLinesForEdit() {
      this.quotation_lines.forEach((line) => {
        line.treatments = [];
        line.lock_teeth = true;

        let treatments_matching = this.selected_treatments.filter(
          (treatment) => {
            if (treatment.quotation_line_id) {
              return treatment.quotation_line_id == line.id;
            }
            return treatment.product_id == line.product_id;
          }
        );

        if (treatments_matching.length) {
          line.teeth = [];
        }

        treatments_matching.forEach((treatment) => {
          line.teeth = line.teeth.concat(treatment.teeth || []);
          line.treatments.push(treatment);
        });
      });
    },

    updateQuotationTreatments() {
      this.selected_treatments.forEach((t) => {
        let quotation_line = this.quotation_lines.find((line) => {
          return t.product.id == line.product.id;
        });

        if (quotation_line) {
          quotation_line.treatments = quotation_line.treatments || [];
          quotation_line.treatmets.push(t);
        }
      });
    },
    showNew(selected_treatments, available_treatments) {
      this.quotation_id = 0;
      this.notes = "";
      this.reject_reason = "";
      this.selected_treatments = WabiDent.cloneObj(selected_treatments);
      this.available_treatments = WabiDent.cloneObj(available_treatments);
      this.tariff_id = null;
      this.updateQuotationLines();

      this.is_editing = false;
      this.expiry_date = moment
        .utc(this.quotation_date)
        .add(1, "M")
        .toDate()
        .toISODate();
      this.quotation_date = new Date().toISODate();
      this.approved_at = null;
      this.user_id = null;
      this.assigned_doctor_id = null;
      this.recommends_doctor_id = null;
      this.hide_total = false;
      this.selected_product = null;

      this.getQuotationCode();
      this.$refs.modal.show();
    },
    showEdit(quotation, available_treatments) {
      this.quotation_id = quotation.id;
      this.notes = quotation.notes;
      this.reject_reason = quotation.reject_reason;
      this.is_editing = true;
      this.tariff_id = quotation.tariff_id;

      this.quotation_date = moment
        .utc(quotation.created_at)
        .toDate()
        .toISODate();
      this.selected_product = null;

      if (quotation.expiry_date) {
        this.expiry_date = moment
          .utc(quotation.expiry_date)
          .toDate()
          .toISODate();
      } else {
        this.expiry_date = null;
      }

      if (quotation.approved_at) {
        this.approved_at = moment.utc(quotation.approved_at).toDate();
      } else {
        this.approved_at = null;
      }

      this.quotation_date = moment
        .utc(quotation.created_at)
        .toDate()
        .toISODate();
      this.quotation_lines = WabiDent.cloneObj(quotation.quotationlines);
      this.selected_treatments = WabiDent.cloneObj(quotation.treatments);
      this.user_id = quotation.user_id;

      this.available_treatments = WabiDent.cloneObj(
        available_treatments
      ).concat(this.selected_treatments);

      this.assigned_doctor_id = quotation.assigned_doctor_id;
      this.recommends_doctor_id = quotation.recommends_doctor_id;
      this.hide_total = quotation.hide_total;

      this.updateQuotationLinesForEdit();
      this.$refs.modal.show();
    },
    addTreatment(ev) {
      let treatment = this.selected_add_teeth;
      if (treatment) {
        this.selected_treatments.push(treatment);

        let line = this.quotation_lines.find((line) => {
          return line.product.id == treatment.product.id;
        });

        if (line && !this.quotation_disable_grouping) {
          line.quantity += 1;
          line.teeth = line.teeth.concat(treatment.teeth);
          line.treatments.push(treatment);
        } else {
          this.quotation_lines.push({
            product: treatment.product,
            quantity: 1,
            treatments: [treatment],
            price: this.getProductPrice(treatment.product),
            discount: 0,
            abs_discount: 0,
            teeth: treatment.teeth ? treatment.teeth : [],
            faces: treatment.custom_position ? treatment.custom_position : [],
            is_approved: false,
            treatment_pack_id: null,
          });
        }
      }
      this.selected_add_teeth = "";
    },
    removeQuotationLine(index) {
      let line = this.quotation_lines[index];
      let removed_product_id = line.product.id;

      this.selected_treatments = this.selected_treatments.filter((t) => {
        return t.product.id != removed_product_id;
      });
      this.quotation_lines.splice(index, 1);
    },
    print() {
      this.submitQuotation((data) => {
        this.$refs.modal.hide();
        window.open(`/quotation/${data.id}/pdf`, "_blank");
      });
    },
    sendMail() {
      this.submitQuotation((data) => {
        this.$refs.modal.hide();
        this.msgwindow.info("Enviando ...");
        axios
          .get(`/quotation/${data.id}/email`)
          .then((response) => {
            let data = response.data;
            if (data.error) {
              this.msgwindow.error(data.message);
            } else {
              this.msgwindow.success(
                "Enviado por correo a " + this.customer.email
              );
            }
          })
          .catch((error) => {
            console.log("[ERR] sendQuotationEmail ", error);
            this.msgwindow.error("Error enviando !");
          });
      }, "mail");
    },
    saveInvoice() {
      this.errorwindow.show(
        "Confirmación",
        "Al generar factura se aprobará. ¿Seguro?",
        "Sí, Aprobar",
        "Cancelar",
        () => {
          this.submitQuotation((data) => {
            this.msgwindow.success("Factura creada ");
            this.$refs.modal.hide();
          }, "invoice");
        }
      );
    },
    submitQuotation(callback, action = null) {
      if (!this.can_save) return;
      if (this.is_editing) {
        this.errorwindow.show(
          "Advertencia",
          "<p>Se creará un tratamiento para todas aquellas lineas de presupuesto que no tengan tratamiento asignado.<p>" +
          "Por favor, revisa los  <b>TRATAMIENTOS SIN PLANIFICAR</b> y los <b>TRATAMIENTOS IMPORTADOS CLINIWIN</b>, ya que podría haber duplicados",
          "Guardar",
          "Cancelar",
          () => {
            this.modifyQuotation(callback, action);
          }
        );
      } else {
        this.saveQuotation(callback, action);
      }
    },
    submitApproval() {
      this.errorwindow.show(
        "Confirmación",
        "¿Quieres aprobarlo directamente?<br>Puedes volver a abrirlo en la pestaña 'Facturación'",
        "Aprobar",
        "Cancelar",
        () => {
          this.submitQuotation(null, "approve");
        }
      );
    },
    onDelete() {
      this.errorwindow.show(
        "Confirmación",
        "¿Quieres borrar el plan?<br> Los tratamientos asociados se quedarán sin planificar y se tendrán que borrar a mano.",
        "Borrar",
        "Cancelar",
        () => {
          this.onDeleteConfirm();
        }
      );
    },
    onDeleteConfirm() {
      if (!this.is_loading) {
        this.is_loading = true;
        axios
          .post(
            `/customer/${this.customer.id}/quotation/${this.quotation_id}`,
            { _method: "delete" }
          )
          .then((response) => {
            this.$emit("submit");
            this.msgwindow.success("Borrado con éxito");
            this.$refs.modal.hide();
          })
          .catch((err) => {
            console.log("[ERR] deleteQuotation ", err);
            this.msgwindow.error("Error borrando");
            this.$refs.modal.hide();
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    modifyQuotation(callback, action = null) {
      if (!this.is_loading) {
        this.is_loading = true;
        var params = {
          quotation_id: this.quotation_id,
          lines: this.quotation_lines.map((x) => {
            return {
              product: x.product.id,
              quantity: x.quantity,
              price: x.price,
              discount: x.discount,
              abs_discount: x.abs_discount,
              teeth: x.teeth,
              faces: x.faces,
              is_approved: x.is_approved,
              treatment_pack_id: x.treatment_pack_id || null,
              treatments: x.treatments
                ? x.treatments.map((x) => {
                  return x.id;
                })
                : [],
            };
          }),
          treatments: this.selected_treatments.map((x) => x.id),
          code: this.quotation_code,
          action: action,
          clinic_id: this.clinic ? this.clinic.id : null,
          notes: this.notes,
          reject_reason: this.reject_reason,
          expiry_date: this.expiry_date,
          hide_total: this.hide_total,
          assigned_doctor_id: this.assigned_doctor_id,
          recommends_doctor_id: this.recommends_doctor_id,
          created_at: this.quotation_date,
          tariff_id: this.tariff_id,
        };

        axios
          .post(
            `/customer/${this.customer.id}/quotation/${this.quotation_id}`,
            params
          )
          .then((response) => {
            this.$emit("submit");
            this.msgwindow.success("Modificado con éxito");
            if (callback) {
              callback(response.data);
            } else {
              this.$refs.modal.hide();
            }
          })
          .catch((error) => {
            console.log("[ERR] modifyQuotation", error);
            this.msgwindow.error("Error modificando");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    saveQuotation(callback, action = null) {
      if (!this.is_loading) {
        this.is_loading = true;
        var params = {
          lines: this.quotation_lines.map((x) => {
            return {
              product: x.product.id,
              quantity: x.quantity,
              price: x.price,
              discount: x.discount,
              abs_discount: x.abs_discount,
              teeth: x.teeth,
              faces: x.faces,
              is_approved: x.is_approved,
              per_tooth: x.per_tooth ? 1 : 0,
              treatment_pack_id: x.treatment_pack_id || null,
              treatments: x.treatments
                ? x.treatments.map((x) => {
                  return x.id;
                })
                : [],
            };
          }),
          treatments: this.selected_treatments.map((x) => x.id),
          code: this.quotation_code,
          action: action,
          clinic_id: this.clinic ? this.clinic.id : null,
          notes: this.notes,
          reject_reason: this.reject_reason,
          expiry_date: this.expiry_date,
          hide_total: this.hide_total,
          assigned_doctor_id: this.assigned_doctor_id,
          recommends_doctor_id: this.recommends_doctor_id,
          created_at: this.quotation_date,
          tariff_id: this.tariff_id,
        };

        axios
          .post(`/customer/${this.customer.id}/quotation`, params)
          .then((response) => {
            this.$emit("submit");
            this.msgwindow.success("Creado con éxito");
            if (callback) {
              callback(response.data);
            } else {
              this.$refs.modal.hide();
            }
          })
          .catch((error) => {
            console.log("[ERR] saveQuotation", error);
            this.msgwindow.error("Error creando");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    getQuotationCode() {
      axios
        .get("/quotation/code")
        .then((response) => {
          this.quotation_code = response.data;
        })
        .catch((error) => {
          this.quotation_code = "";
        });
    },
    fillSearchedProducts(data) {
      if (!data) {
        this.searched_products = [];
        this.products = [];
        return;
      }

      this.searched_products = data;

      let ps = this.searched_products.map((p) => {
        return {
          label: p.name,
          value: p,
        };
      });

      this.products = ps;
    },
    searchProducts(search, loading = null) {
      if (loading) {
        loading(true);
      }
      axios
        .get("/product", {
          params: {
            size: 100,
            search: search,
            product_category_id: this.product_category_id,
          },
        })
        .then((response) => {
          if (loading) {
            loading(false);
          }
          this.fillSearchedProducts(response.data.data);
        })
        .catch((error) => {
          console.log("[ERR] searchProducts:", error);
        })
        .then(() => {
          if (loading) {
            loading(false);
          }
        });
    },
    loadCategories() {
      axios.get("/product/hierarchy").then((response) => {
        this.hierarchy = response.data;
      });
    },
    addCategory(cat, ret, level) {
      let prefix = "-".repeat(level);

      ret.push({
        id: cat.id,
        slug: cat.slug,
        name: prefix + cat.name,
        parent_id: cat.parent_id,
        level: level,
      });

      cat.children.forEach((subcat) => {
        this.addCategory(subcat, ret, level + 1);
      });
    },
    addProductToQuotation() {
      // Adds a single product to a quotation
      if (!this.selected_product) return;
      const product = this.selected_product.value;

      this.quotation_lines.push({
        product: product,
        quantity: 1,
        treatments: [],
        price: this.getProductPrice(product),
        discount: 0,
        abs_discount: 0,
        teeth: [],
        faces: [],
        per_tooth: false,
        is_approved: false,
        treatment_pack_id: null,
      });
    },
    addPack() {
      // Show Choose Pack dialog
      this.$refs.choosepack.show();
    },
    doAddPack(pack) {
      // Add quotation lines from pack
      pack.pack_lines.forEach((line) => {
        for (let i = 0; i < line.quantity; i++) {
          this.quotation_lines.push({
            product: line.product,
            quantity: 1,
            treatments: [],
            price: line.price ? line.price : this.getProductPrice(line.product),
            discount: line.discount,
            abs_discount: (line.abs_discount / line.quantity).toFixed(4),
            teeth: [],
            faces: [],
            is_approved: false,
            treatment_pack_id: pack.id,
          });
        }
      });
    },
  },
  mounted() {
    this.getQuotationCode();
    this.loadCategories();
  },
};
</script>

<style lang="scss">
#customer-show-quotation {
  .handle {
    cursor: grab;
  }

  .quotation-line+.quotation-line {
    border-top: 1px var(--theme-grey-bg) solid;
  }

  .quotation-line-order {
    &__num {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: bold;
      width: 25px;
      height: 25px;
      margin-left: 2px;
      border: 1px var(--theme-grey) solid;
      border-radius: 50%;
    }

    &__buttons {
      font-size: 12px;
    }

    &__btn {
      color: var(--theme-color);
      transition: 0.3s;
      cursor: pointer;
    }
  }

  .customer-show-quotation__left {
    padding-right: 20px;
  }

  .customer-show-quotation__right {
    border-left: 3px var(--theme-grey-bg) solid;
    padding-left: 20px;
  }

  .modal-dialog {
    max-width: 90vw;
    border-radius: 0;
  }

  .modal-header {
    background-color: var(--theme-grey-bg);
  }

  .modal-header,
  .modal-content {
    border-radius: 0;
  }

  .modal-title {
    margin: 0;
    text-align: left;
    font-size: 18px;
  }

  .close {
    top: 15px;
  }

  .modal-body {
    padding: 20px;
  }

  .treatments-table {
    thead {
      th {
        border-top: none;
        border-bottom: 1px var(--theme-grey) solid;
        color: var(--theme-grey);
        font-size: 11px;
        letter-spacing: 0.16px;
        font-weight: 300;
        line-height: 1.82;

        input {
          margin: 0;
          width: 80px;
        }
      }
    }

    tbody {
      min-height: 282px !important;

      td {
        font-size: 16px;
        color: var(--theme-text-color);
        border: none;
        vertical-align: bottom;

        input {
          margin: 0;
          width: 80px;
        }

        .total {
          display: block;
          font-size: 11px;
          line-height: 1.82;
          font-weight: 300;
          color: var(--theme-grey);
          letter-spacing: 0.16px;
          margin-top: 9px;
          border-top: 1px var(--theme-grey) solid;
          width: 100%;
          padding: 7px;
        }
      }

      .trash-icon {
        cursor: pointer;
        color: var(--theme-grey);
        transition: all 0.2s;

        &:hover {
          color: var(--theme-color-absent);
        }

        svg {
          fill: currentColor;
        }
      }
    }
  }

  .customer-show-quotation__product-selector {
    &>* {
      margin: 0 5px;
    }
  }

  .customer-info {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    align-content: center;
    padding: 0;
    margin-bottom: 30px;

    .customer-photo {
      width: 70px;
      height: 70px;
      max-height: 70px;
      background-size: cover;
      background-position: center center;
      border-radius: 35px;
    }

    .customer-data {
      padding: 10px;
      font-size: 16px;
      line-height: 1.25;
      color: var(--theme-grey);
      text-align: center;

      &__name {
        color: var(--theme-text-color);
        margin-bottom: 10px;
        font-weight: 500;
        text-transform: uppercase;
      }
    }
  }

  .buttons-column {
    button {
      flex: 1 0 180px;
    }

    button+button {
      margin-left: 10px;
    }

    .btn-link+.btn-link {
      margin-left: 10px;
    }

    .btn-sendmail,
    .btn-print {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 13px;
      height: 100%;
      cursor: pointer;
      display: block;
      width: 24px;
      color: var(--theme-grey) !important;
      transition: all 0.2s;
      fill: currentColor;

      &:hover {
        color: var(--theme-color) !important;
      }

      svg {
        transition: all 0.2s;
        fill: currentColor;
      }
    }
  }
}
</style>
